var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlocknft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104.14 113.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#231f20;}.cls-2,.cls-4{fill:none;stroke:#fff;stroke-miterlimit:10;}.cls-3,.cls-5{fill:#fff;}.cls-4{stroke-width:0.35px;}.cls-5{font-size:12px;font-family:Arial-BoldMT, Arial;font-weight:700;letter-spacing:0.05em;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Text"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "35.62 23.33 4.79 23.33 4.79 54.15"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "34.53 23.33 4.79 23.33 4.79 53.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "31.22 19.24 30.54 19.97 34.15 23.33 30.54 26.69 31.22 27.42 35.62 23.33 31.22 19.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "0.7 49.76 1.44 49.07 4.79 52.69 8.15 49.07 8.88 49.76 4.79 54.15 0.7 49.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "95.13 34.71 95.13 11.95 75.43 0.58 55.72 11.95 55.72 34.71 75.43 46.08 95.13 34.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "39.91 101.49 39.91 78.74 20.2 67.36 0.5 78.74 0.5 101.49 20.2 112.87 39.91 101.49"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 0.5,
    y1: 78.74,
    x2: 20.2,
    y2: 90.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 39.91,
    y1: 78.74,
    x2: 20.2,
    y2: 90.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 20.2,
    y1: 112.87,
    x2: 20.2,
    y2: 90.12
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "39.91 101.49 39.91 78.74 20.2 67.36 0.5 78.74 0.5 101.49 20.2 112.87 39.91 101.49"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "60.02 90.12 90.84 90.12 90.84 59.29"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "61.1 90.12 90.84 90.12 90.84 60.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "64.42 94.21 65.1 93.47 61.48 90.12 65.1 86.76 64.42 86.03 60.02 90.12 64.42 94.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "94.93 63.69 94.2 64.37 90.84 60.76 87.48 64.37 86.75 63.69 90.84 59.29 94.93 63.69"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-5",
    transform: "translate(63.17 28.38)"
  }, "NFT")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlocknft);
export default __webpack_public_path__ + "static/media/blocknft.5798ddb4cd347d08d0283154a64d08bb.svg";
export { ForwardRef as ReactComponent };